import React, { useRef } from 'react';

const SIZES = ['peek', 'half', 'full'];

export default function MobileSheetHandle({ size, onChange, label, expandLabel, collapseLabel }) {
  const startY = useRef(null);
  const didDrag = useRef(false);
  const move = (direction) => {
    const index = SIZES.indexOf(size);
    onChange(SIZES[Math.max(0, Math.min(SIZES.length - 1, index + direction))]);
  };

  return (
    <button
      aria-label={size === 'full' ? collapseLabel : expandLabel}
      aria-expanded={size !== 'peek'}
      className="mobile-sheet-handle"
      onClick={() => {
        if (didDrag.current) {
          didDrag.current = false;
          return;
        }
        onChange(size === 'full' ? 'half' : 'full');
      }}
      onKeyDown={(event) => {
        if (['ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          if (event.key === 'Home') onChange('peek');
          else if (event.key === 'End') onChange('full');
          else move(event.key === 'ArrowUp' ? 1 : -1);
        }
      }}
      onPointerDown={(event) => {
        startY.current = event.clientY;
        didDrag.current = false;
        event.currentTarget.setPointerCapture?.(event.pointerId);
      }}
      onPointerUp={(event) => {
        if (startY.current !== null) {
          const delta = startY.current - event.clientY;
          if (Math.abs(delta) > 24) {
            didDrag.current = true;
            move(delta > 0 ? 1 : -1);
          }
        }
        startY.current = null;
      }}
      onPointerCancel={() => { startY.current = null; }}
      type="button"
    >
      <span aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </button>
  );
}
